import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { IPaymentMethod } from "./paymentMethodModel";

export const findAllPaymentMethod = createAsyncThunk(
  "PaymentMethod/FindAllPaymentMethod",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/PaymentMethod/FindAllPaymentMethod`
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching PaymentMethod:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertOrUpdatePaymentMethod = createAsyncThunk(
  "PaymentMethod/InsertOrUpdatePaymentMethod",
  async (formData: FormData) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/PaymentMethod/InsertOrUpdatePaymentMethod`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating/updating PaymentMethod:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findByIDPaymentMethod = createAsyncThunk(
  "PaymentMethod/FindByIDPaymentMethod",
  async (ID: string | number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/PaymentMethod/FindByIDPaymentMethod`,
        { ID }
      );
      return response.data?.Data as IPaymentMethod;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching PaymentMethod:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePaymentMethod = createAsyncThunk(
  "PaymentMethod/DeletePaymentMethod",
  async (ID: string | number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/PaymentMethod/DeletePaymentMethod`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting PaymentMethod:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
